module.exports = __webpack_public_path__ + "static/media/phone.a1bbdaf9.png";